import React, { useCallback, useContext, useState, useRef } from "react"
import app from "../Util/Fire"
import { AuthContext } from "../Auth/Auth"
import { Link as RouterLink } from "react-router-dom"
import { Redirect, withRouter } from "react-router"

import "./SignIn.css"
import { UIAlertContext } from "../ui/UIAlert/UIAlert"
import  validateEmail from "../Util/Validate"

import firebase from "firebase/app"
import "firebase/auth"

const SignInSideBar = ({ history }) => {
    // TODO: Set default to user's check
    const [rememberUser, setRememberUser] = useState(!!localStorage.getItem("@flag/remember-me"))

    const { confirmationModal } = useContext(UIAlertContext)

    const { currentUser } = useContext(AuthContext)
    const {} = useContext(UIAlertContext)
    const loginClick = useRef(null)
    const emailInput = useRef(null)
    const passwordInput = useRef(null)
    const demoEmailInput = useRef(null)

    const currentYear = new Date().getFullYear()

    const handleLogin = useCallback(
        async (event) => {
            event.preventDefault()
            const { email, password } = event.target.elements
            try {
                console.log(rememberUser)
                await app
                    .auth()
                    .setPersistence(
                        rememberUser ? firebase.auth.Auth.Persistence.LOCAL : firebase.auth.Auth.Persistence.SESSION
                    )
                await app.auth().signInWithEmailAndPassword(email.value, password.value)
            } catch (error) {
                confirmationModal(null, error.message)
            }
        },
        [history, rememberUser]
    )

    if (currentUser) {
        return <Redirect to="/dashboard" />
    }

    function handleRememberUser(e) {
        console.log(e.target.checked)
        if (e.target.checked) localStorage.setItem("@flag/remember-me", "true")
        else localStorage.removeItem("@flag/remember-me")

        setRememberUser(e.target.checked)
    }

    function demoLogin() {
        let demoEmail = demoEmailInput.current.value.trim()
        if(!validateEmail(demoEmail)) {
            //TODO: Once the localization PR gets merged update this to use the translation var
            confirmationModal(null, "Please enter a valid email address")
            return
        }
        console.log("Demoing for email " + demoEmail)
        // Initialize and Track the event
        let pendo_object = {
            visitor_id: "demo@climate.ai",
            account_id: "demo@climate.ai",
        }
        //Note: This pendo.init is necessary so that the track event gets attributed to the `demo@climate.ai`
        window["wrapper_pendo"](pendo_object)
        window["wrapper_pendo_tracking"]('demo_skip', {'email': demoEmail})

        // Login 
        emailInput.current.value = "pacificseeds@climate.ai"
        passwordInput.current.value = "climatedemo2021"
        loginClick.current.click()
    }

    return (
        <div className="sign-in__screen">
            <div className="sign-in">
                <div className="sign-in__card">
                    <img alt="Skip logo" className="sign-in__logo" src="/skip-logo.png" />
                    <div className="sign-in__title">Demo</div>
                    <form className="sign-in__form" noValidate>
                        <div className="sign-in__input-group">
                            <label>Email Address</label>
                            <input placeholder="Required for Demo" type="email" id="demo_email" name="demo_email" ref={demoEmailInput} />
                        </div>
                    </form>
                    <div className="sign-in__demo-button" onClick={demoLogin}>
                        Try a Demo
                    </div>
                    <div className="sign-in__hr"></div>
                    <div className="sign-in__title">Log In</div>
                    <form className="sign-in__form" noValidate onSubmit={handleLogin}>
                        <div className="sign-in__input-group">
                            <label>Email Address</label>
                            <input placeholder="Email Address" type="email" id="email" name="email" ref={emailInput} />
                        </div>
                        <div className="sign-in__input-group">
                            <label>Password</label>
                            <input
                                name="password"
                                placeholder="********"
                                type="password"
                                id="password"
                                ref={passwordInput}
                            />
                        </div>
                        <RouterLink
                            id="restore-password-link__login"
                            className="sign-in__restore-password"
                            to="/restore-password"
                        >
                            Forgot your password?
                        </RouterLink>

                        <div className="sign-in-side__checkbox-container">
                                    <span className="sign-in-side__checkbox">
                                        <input
                                            type="checkbox"
                                            checked={rememberUser}
                                            onChange={handleRememberUser}
                                            id="remember-me-checkbox__log-in"
                                            className="sign-in-side__checkbox-input"
                                        />
                                        <label className="sign-in-side__checkbox-label">
                                            {rememberUser && (
                                                <svg
                                                    width="90%"
                                                    height="90%"
                                                    viewBox="0 0 8 6"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M2.74982 4.73743L1.01232 2.99993L0.420654 3.58743L2.74982 5.9166L7.74982 0.916601L7.16232 0.329102L2.74982 4.73743Z"
                                                        fill="white"
                                                    />
                                                </svg>
                                            )}
                                        </label>
                                    </span>

                                    <div className="sign-in-side__checkbox-text">Remember me</div>
                                </div>

                        <button
                            type="submit"
                            id="login-button__login"
                            className="sign-in__button submit"
                            ref={loginClick}
                        >
                            Log In
                        </button>
                    </form>
                    <div className="sign-in__hr"></div>
                    <a className="sign-in__sign-up">Don't have an account?</a>
                    <a href="https://skip.payment.climate.ai/" className="sign-in__button sign-up">
                        Create Account
                    </a>
                    <span className="sign-in__sign-up-rights">© Pacific Seeds {currentYear}, All Rights Reserved</span>
                    <div className="sign-in__hr"></div>
                    <div className="sign-in__powered-by">
                        <a className="powered-by__tag" href="https://www.climate.ai" target="_blank">
                            Powered by
                            <img alt="ClimateAI logo" src="/Climate-AI-Color-Logo.png" />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withRouter(SignInSideBar)
